import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import AnalysisCard from "../../Components/AnalysisCard/AnalysisCard";
import {
    ClassOutlined,
    AttachMoney,
    Leaderboard,
    Assignment,
    SolarPower,
    DocumentScanner,
    ContentPasteOff,
} from "@mui/icons-material";
import styled from "styled-components";
import LinerCaharts from "../../Components/Charts/LinerCaharts";
import DoughnutCharts from "../../Components/Charts/DoughnutCharts";
import { useDispatch, useSelector } from "react-redux";
import {
    cardsReset,
    GetEverSignDocumentSigned,
    GetEverSignDocumentUnSigned,
    GetLeadsCard,
    GetSolutionsCount,
} from "../../Redux/Analysis/AnalysisSlice";
import AnalysisForm from "./AnalysisForm";
import { Container } from "@mui/system";

const Analysis = ({ mainUser }) => {
    const MAIN_USER = mainUser ? mainUser?.data : "";

    const dispatch = useDispatch();
    const {
        start_date,
        end_date,
        solutions,
        leads,
        documents_signed,
        documents_unsigned,
        isError,
        errors,
    } = useSelector((state) => state.cards);
    const solutionsVal = solutions?.data || 0;
    const leadsVal = leads?.data || 0;
    // const leadsVal =  0;

    const signedCount = documents_signed?.data?.count || 0;
    const signedCost = documents_signed?.data?.cost || 0;
    const unsignedCount = documents_unsigned?.data?.count || 0;
    const unsignedCost = documents_unsigned?.data?.cost || 0;
    useEffect(() => {
        const CallCardsApis = async () => {
            await dispatch(
                GetLeadsCard({ start_date: start_date, end_date: end_date })
            );
            await dispatch(
                GetSolutionsCount({
                    start_date: start_date,
                    end_date: end_date,
                })
            );
            await dispatch(
                GetEverSignDocumentSigned({
                    start_date: start_date,
                    end_date: end_date,
                })
            );
            await dispatch(
                GetEverSignDocumentUnSigned({
                    start_date: start_date,
                    end_date: end_date,
                })
            );
            await dispatch(cardsReset());
        };
        CallCardsApis();
    }, [start_date, end_date, dispatch]);

    useEffect(() => {
        if (isError) {
        }
    }, [isError, errors]);

    return (
        <>
            <AnalysisContainer>
                <Grid container>
                    <Grid item xs={12}>
                        <AnalysisForm />
                    </Grid>
                </Grid>
                <Container>
                    <GridConainer>
                        <AnalysisCard
                            className="main"
                            icon={<AttachMoney />}
                            name="Leads"
                            value={leadsVal}
                            iconAb={<AttachMoney />}
                            url="leads"
                        />

                        <AnalysisCard
                            className="first"
                            icon={<DocumentScanner />}
                            name="Signed Contracts"
                            value={signedCount}
                            cost={signedCost}
                            iconAb={<DocumentScanner />}
                            url="eversign-documents/signed=1"
                        />

                        <AnalysisCard
                            className="third"
                            icon={<ContentPasteOff />}
                            name="Unsigned Contracts"
                            value={unsignedCount}
                            cost={unsignedCost}
                            iconAb={<ContentPasteOff />}
                            url="eversign-documents/signed=2"
                        />

                        <AnalysisCard
                            className="forth"
                            icon={<Assignment />}
                            name="All solutions"
                            value={solutionsVal}
                            iconAb={<Assignment />}
                            url="solutions"
                        />
                    </GridConainer>
                </Container>
                <Grid container>
                    <Grid item md={8}>
                        <ChartContainer>
                            <LinerCaharts className="line" />
                        </ChartContainer>
                    </Grid>
                    <Grid item md={4}>
                        <ChartContainer>
                            <DoughnutCharts />
                        </ChartContainer>
                    </Grid>
                </Grid>
            </AnalysisContainer>
        </>
    );
};
const AnalysisContainer = styled.div`
    width: 100%;
    overflow: hidden;
`;
const GridConainer = styled.div`
    display: grid;
    margin: 1rem;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    /* grid-template-rows: auto; */
    gap: 1rem;
    /* grid-template-areas: "main  first secound third"; */

    /* @media screen and (max-width: 992px) {
    grid-template-areas:
      "main  main secound secound"
      "first first third third"
      "forth forth forth forth";
  }
  @media screen and (max-width: 768px) {
    grid-template-areas:
      "main"
      "secound"
      "first"
      "third"
      "forth ";
  } */
`;

const ChartContainer = styled.div`
    padding: 2rem;
    margin: 1rem;
    background: var(--white);
    border-radius: var(--border-radius);
    box-shadow: 0 5px 8px var(--box-shadow);

    overflow: hidden;
    .pie {
        margin: 1.2rem 0;
        width: 100%;
        overflow: hidden;
    }
    .line {
        margin: 1rem 0;
        width: 100%;
        overflow: hidden;
    }
`;

export default Analysis;
